export enum clothColors {
  red,
  blue,
  green,
  yellow,
  white
}
